import React from "react";
import { connect } from "react-redux";
import BlockPlafond from "./BlockPlafond";
import { Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import PieChart from "../Base/PieChart";
import PropTypes from 'prop-types';

class HomeAg extends React.Component {


    render() {
        let dataEnseigne = undefined
        if (this.props.encoursEnseigne !== undefined) {
            dataEnseigne = this.props.encoursEnseigne
        }
        let dataProduit = undefined
        if (this.props.encoursProduits !== undefined) {
            dataProduit = this.props.encoursProduits
        }
        return (
            <>
                <div className="row gy-4">

                    <div className="col-xl-4 col-md-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                        {this.props.encoursEnseigne !== undefined ?
                            <BlockPlafond  {...this.props} />
                            : null
                        }
                    </div>


                    <PieChart className="col-xl-4 col-md-6 aos-init aos-animate" title='- REPARTITION PAR ENSEIGNE -' data={dataEnseigne} />
                    <PieChart className="col-xl-4 col-md-6 aos-init aos-animate" title='- REPARTITION PAR PRODUIT -' data={dataProduit} />
                    
                </div>

               
            </>
        )
    }
}


const mapStateToProps = (state) => {
    return ({
        JWTToken: state.authentication.JWTToken,
        encoursProduits: state.app.encoursProduits,
        encoursEnseigne: state.app.encoursEnseigne,
        plafond: state.app.plafond,
        parrain: state.app.parrain,
        currentClient: state.authentication.currentClient,

    })
}

HomeAg.propTypes = {
    JWTToken: PropTypes.string,
    encoursProduits: PropTypes.array,
    encoursEnseigne: PropTypes.array,
    plafond: PropTypes.number || PropTypes.string,
    parrain: PropTypes.string,
    currentClient: PropTypes.object
};

export default connect(mapStateToProps)(HomeAg);
